(function () {
  'use strict';

  // ── addToCartAndRedirect ─────────────────────────────────────────────
  // Redirects to /cart by default. Layouts that set window.NIUD_CART_DRAWER
  // opt out of the redirect and get niud:cart:added / niud:cart:error events
  // instead, which niud-cart-drawer.js listens for.
  function addToCartAndRedirect(variantId, quantity) {
    var useDrawer = window.NIUD_CART_DRAWER === true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status === 422) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: data.description }
        }));
        if (useDrawer) {
          document.dispatchEvent(new CustomEvent('niud:cart:error', {
            detail: { message: data.description }
          }));
        }
        return;
      }
      var tracked = trackAddToCart(variantId, quantity);
      if (useDrawer) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('niud:cart:added', {
              detail: { cart: cart, added: data }
            }));
          });
      }
      return tracked.then(function () { window.location.href = '/cart'; });
    })
    .catch(function (e) {
      console.error('ATC error:', e);
      if (useDrawer) {
        document.dispatchEvent(new CustomEvent('niud:cart:error', {
          detail: { message: 'Something went wrong. Please try again.' }
        }));
      }
    });
  }

  // ── PostHog tracking ────────────────────────────────────────────────
  // add_to_cart and high_click_session are replay triggers: they start a
  // recording for sessions the 80% replay sample skipped. The cart attributes
  // carry the PostHog ids into checkout, where the Shopify custom pixel
  // (pixels/posthog-checkout.js) links checkout and purchase to this session.
  function phReady() {
    return window.posthog && typeof window.posthog.get_session_id === 'function';
  }

  function trackAddToCart(variantId, quantity) {
    if (!phReady()) return Promise.resolve();
    window.posthog.capture('add_to_cart', { variant_id: variantId, quantity: quantity || 1 }, { send_instantly: true });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        _ph_distinct_id: window.posthog.get_distinct_id(),
        _ph_session_id: window.posthog.get_session_id()
      } })
    }).catch(function () {});
  }

  // The count lives in sessionStorage so clicks add up across pages.
  function trackHighClicks() {
    var LIMIT = 10;
    document.addEventListener('click', function () {
      var count = 0;
      try {
        count = Number(sessionStorage.getItem('niud_clicks') || 0) + 1;
        sessionStorage.setItem('niud_clicks', count);
      } catch (e) { return; }
      if (count === LIMIT && phReady()) window.posthog.capture('high_click_session', { clicks: LIMIT });
    }, true);
  }

  // ── inViewObserver ──────────────────────────────────────────────────
  function inViewObserver() {
    var els = document.querySelectorAll('.fade-in');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }
    els.forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          el.classList.add('in-view');
          io.disconnect();
        }
      }, { threshold: 0.1 });
      io.observe(el);
    });
  }

  // ── NiudCarousel ────────────────────────────────────────────────────
  function NiudCarousel(opts) {
    var container = typeof opts.container === 'string'
      ? document.querySelector(opts.container)
      : opts.container;
    if (!container) return;

    var track = container.querySelector(opts.trackSel || '.niud-carousel__track');
    var slides = container.querySelectorAll(opts.slideSel || '.niud-carousel__slide');
    var prevBtn = container.querySelector(opts.prevSel || '[data-carousel-prev]');
    var nextBtn = container.querySelector(opts.nextSel || '[data-carousel-next]');
    var dots = container.querySelectorAll(opts.dotSel || '[data-carousel-dot]');
    var segs = container.querySelectorAll(opts.segSel || '[data-carousel-seg]');
    var viewport = opts.viewportSel ? container.querySelector(opts.viewportSel) : null;
    var activeClass = opts.activeClass || 'active';
    var dotActiveClass = opts.dotActiveClass || activeClass + '--active';
    var segActiveClass = opts.segActiveClass || dotActiveClass;
    var autoInterval = opts.autoInterval || 0;
    var mobileOnly = opts.mobileOnly || false;

    var cur = 0;
    var total = slides.length;
    var timer = null;
    var paused = false;
    var resumeTimer = null;
    var touchStartX = 0;
    var dragOffset = 0;
    var isDragging = false;
    var slideWidth = 0;

    function getSlideWidth() {
      if (viewport) return viewport.offsetWidth;
      return track ? track.offsetWidth : (slides[0] ? slides[0].offsetWidth : 0);
    }

    function sizeSlides() {
      if (!opts.translateMode) return;
      slideWidth = getSlideWidth();
      slides.forEach(function (s) { s.style.width = slideWidth + 'px'; });
    }

    function updateDom() {
      slides.forEach(function (s, i) {
        s.classList.toggle(activeClass, i === cur);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle(dotActiveClass, i === cur);
      });
      segs.forEach(function (s, i) {
        s.classList.toggle(segActiveClass, i === cur);
      });
      if (track && opts.translateMode) {
        slideWidth = getSlideWidth();
        track.style.transform = 'translateX(-' + (cur * slideWidth) + 'px)';
      }
      if (opts.onSlide) opts.onSlide(cur, total);
    }

    function goTo(idx, byUser) {
      cur = ((idx % total) + total) % total;
      updateDom();
      if (byUser) {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 4000);
      }
    }

    function startAuto() {
      if (!autoInterval) return;
      clearInterval(timer);
      timer = setInterval(function () {
        if (!paused) {
          if (mobileOnly && window.innerWidth >= 768) return;
          goTo(cur + 1);
        }
      }, autoInterval);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1, true); });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i, true); });
    });
    segs.forEach(function (s, i) {
      s.addEventListener('click', function () { goTo(i, true); });
    });

    if (opts.swipe || opts.drag) {
      var vp = viewport || track;
      if (vp) {
        vp.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
          isDragging = true;
          paused = true;
          if (track && opts.translateMode) track.classList.add('dragging');
        }, { passive: true });

        vp.addEventListener('touchmove', function (e) {
          if (!isDragging) return;
          dragOffset = e.touches[0].clientX - touchStartX;
          if (track && opts.translateMode) {
            slideWidth = getSlideWidth();
            track.style.transform = 'translateX(' + (-(cur * slideWidth) + dragOffset) + 'px)';
          }
        }, { passive: true });

        vp.addEventListener('touchend', function () {
          isDragging = false;
          if (track && opts.translateMode) track.classList.remove('dragging');
          if (Math.abs(dragOffset) > 40) {
            goTo(dragOffset < 0 ? cur + 1 : cur - 1, true);
          } else {
            updateDom();
            resumeTimer = setTimeout(function () { paused = false; }, 4000);
          }
          dragOffset = 0;
        });

        if (opts.drag) {
          vp.addEventListener('mousedown', function (e) {
            touchStartX = e.clientX;
            isDragging = true;
            paused = true;
            if (track && opts.translateMode) track.classList.add('dragging');
          });
          vp.addEventListener('mousemove', function (e) {
            if (!isDragging) return;
            dragOffset = e.clientX - touchStartX;
            if (track && opts.translateMode) {
              slideWidth = getSlideWidth();
              track.style.transform = 'translateX(' + (-(cur * slideWidth) + dragOffset) + 'px)';
            }
          });
          var endDrag = function () {
            if (!isDragging) return;
            isDragging = false;
            if (track && opts.translateMode) track.classList.remove('dragging');
            if (Math.abs(dragOffset) > 40) {
              goTo(dragOffset < 0 ? cur + 1 : cur - 1, true);
            } else {
              updateDom();
              resumeTimer = setTimeout(function () { paused = false; }, 4000);
            }
            dragOffset = 0;
          };
          vp.addEventListener('mouseup', endDrag);
          vp.addEventListener('mouseleave', endDrag);
        }
      }
    }

    window.addEventListener('resize', function () {
      sizeSlides();
      if (track && opts.translateMode) {
        slideWidth = getSlideWidth();
        track.style.transform = 'translateX(-' + (cur * slideWidth) + 'px)';
      }
    });

    sizeSlides();
    updateDom();

    if (autoInterval && container) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { startAuto(); } else { clearInterval(timer); }
      }, { threshold: 0.1 });
      io.observe(container);
    }

    return { goTo: goTo, getCur: function () { return cur; } };
  }

  // ── whyNiudScrolljack ───────────────────────────────────────────────
  function whyNiudScrolljack() {
    var section = document.querySelector('.why');
    if (!section) return;

    var bubbles = section.querySelectorAll('.why__bubble');
    var punchline = section.querySelector('.why__punchline');
    var fired = false;

    var io = new IntersectionObserver(function (entries) {
      if (fired || !entries[0].isIntersecting) return;
      fired = true;
      io.disconnect();

      bubbles.forEach(function (bubble, i) {
        setTimeout(function () {
          bubble.style.opacity = '1';
          bubble.style.transform = 'translateY(0)';
        }, i * 250);
      });

      if (punchline) {
        setTimeout(function () {
          punchline.style.opacity = '1';
          punchline.style.transform = 'translateY(0)';
        }, bubbles.length * 250 + 200);
      }
    }, { threshold: 0.4 });

    io.observe(section);
  }

  // ── beforeAfterSlider ───────────────────────────────────────────────
  function beforeAfterSlider() {
    var slider = document.querySelector('.before-after__slider');
    if (!slider) return;

    var after = slider.querySelector('.before-after__after');
    var divider = slider.querySelector('.before-after__divider');
    var dragging = false;
    var animated = false;

    function setPosRaw(pct) {
      if (after) after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      if (divider) divider.style.left = pct + '%';
    }

    function setPos(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      setPosRaw((x / rect.width) * 100);
    }

    setPosRaw(100);

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !animated) {
        animated = true;
        io.disconnect();
        setTimeout(function () { setPosRaw(0); }, 300);
        setTimeout(function () { setPosRaw(50); }, 1400);
      }
    }, { threshold: 0.4 });
    io.observe(slider);

    slider.addEventListener('mousedown', function () {
      dragging = true;
      slider.classList.add('dragging');
    });
    window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
    window.addEventListener('mouseup', function () {
      dragging = false;
      slider.classList.remove('dragging');
    });

    var handle = slider.querySelector('.before-after__divider');
    if (handle) {
      handle.addEventListener('touchstart', function () {
        dragging = true;
        slider.classList.add('dragging');
      }, { passive: false });
    }
    slider.addEventListener('touchmove', function (e) { if (dragging) { e.preventDefault(); setPos(e.touches[0].clientX); } }, { passive: false });
    slider.addEventListener('touchend', function () {
      dragging = false;
      slider.classList.remove('dragging');
    });
  }

  // ── baCarousel (before/after pair carousel) ───────────────────────────
  function baCarousel() {
    var section = document.querySelector('.before-after');
    if (!section) return;

    var carousel = section.querySelector('.ba-carousel');
    var slides = section.querySelectorAll('.ba-carousel__slide');
    var segs = section.querySelectorAll('.ba-carousel__progress-seg');
    if (!carousel || slides.length < 2) return;

    var cur = 0;
    var timer = null;
    var idleTimer = null;
    var programmatic = false;

    function setActive(idx) {
      cur = idx;
      slides.forEach(function (s, i) { s.classList.toggle('ba-carousel__slide--active', i === idx); });
      segs.forEach(function (s, i) { s.classList.toggle('ba-carousel__progress-seg--active', i === idx); });
      carousel.style.setProperty('--active', idx);
    }

    function scrollTo(idx) {
      programmatic = true;
      carousel.scrollTo({ left: idx * carousel.offsetWidth, behavior: 'smooth' });
      setTimeout(function () { programmatic = false; }, 400);
    }

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(function () {
        var next = (cur + 1) % slides.length;
        setActive(next);
        scrollTo(next);
      }, parseInt(section.querySelector('.ba-carousel').dataset.carouselInterval) || 3000);
    }

    function pauseAndResume() {
      clearInterval(timer);
      clearTimeout(idleTimer);
      idleTimer = setTimeout(startAutoplay, 5000);
    }

    segs.forEach(function (seg, i) {
      seg.addEventListener('click', function () {
        setActive(i);
        scrollTo(i);
        pauseAndResume();
      });
    });

    carousel.addEventListener('scroll', function () {
      if (programmatic) return;
      var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
      if (idx !== cur && idx >= 0 && idx < slides.length) {
        setActive(idx);
        pauseAndResume();
      }
    });

    setActive(0);

    var baObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { startAutoplay(); } else { clearInterval(timer); }
    }, { threshold: 0.1 });
    baObs.observe(section);
  }

  // ── accordion ───────────────────────────────────────────────────────
  function accordion(containerSel, itemSel, toggleSel, openClass) {
    var container = document.querySelector(containerSel);
    if (!container) return;
    var toggles = container.querySelectorAll(toggleSel);
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest(itemSel);
        if (!item) return;
        var isOpen = item.classList.contains(openClass);
        container.querySelectorAll(itemSel).forEach(function (i) { i.classList.remove(openClass); });
        if (!isOpen) item.classList.add(openClass);
        container.querySelectorAll(itemSel).forEach(function (i) {
          var icon = i.querySelector('.faq__icon, .shop__spec-icon, .bshop__spec-icon');
          if (icon) icon.textContent = i.classList.contains(openClass) ? '−' : '+';
        });
      });
    });
  }

  // ── colorSwatchPicker ────────────────────────────────────────────────
  function colorSwatchPicker() {
    var section = document.querySelector('.shop');
    if (!section) return;

    var mainImg = section.querySelector('.shop__gallery-main img');
    var swatches = section.querySelectorAll('.shop__color-option');
    var thumbs = section.querySelectorAll('.shop__gallery-thumb');

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.querySelector('.shop__color-swatch').classList.remove('active');
        });
        btn.querySelector('.shop__color-swatch').classList.add('active');

        var variantImg = btn.dataset.variantImage;
        if (variantImg && mainImg) {
          mainImg.src = variantImg;
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          if (thumbs[0]) thumbs[0].classList.add('active');
        }

        var variantId = btn.dataset.variantId;
        if (variantId && window.NIUD) window.NIUD.selectedVariantId = variantId;
        var hiddenInput = document.getElementById('shop-atc-variant-id');
        if (hiddenInput && variantId) hiddenInput.value = variantId;
      });
    });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var src = thumb.querySelector('img');
        if (src && mainImg) mainImg.src = src.src;
      });
    });

    if (thumbs[0]) thumbs[0].classList.add('active');
    if (swatches[0]) swatches[0].querySelector('.shop__color-swatch').classList.add('active');
  }

  // ── stickyAtcBar ────────────────────────────────────────────────────
  function stickyAtcBar() {
    var bar = document.querySelector('.sticky-atc');
    if (!bar) return;
    var atcBtn = document.getElementById('shop-atc');

    function syncPadding() {
      var show = bar.classList.contains('visible');
      document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
    }

    function setVisible(show) {
      bar.classList.toggle('visible', show);
      syncPadding();
    }

    window.NIUD = window.NIUD || {};
    window.NIUD.syncStickyPadding = syncPadding;

    window.addEventListener('scroll', function () {
      var pastHero = window.scrollY > window.innerHeight * 0.8;
      if (!atcBtn) {
        setVisible(pastHero);
        return;
      }
      var rect = atcBtn.getBoundingClientRect();
      var atcInView = rect.top < window.innerHeight && rect.bottom > 0;
      setVisible(pastHero && !atcInView);
    }, { passive: true });
  }

  // ── Variant Picker Modal ──────────────────────────────────────────────
  function initVariantPickerModal() {
    var overlay = document.getElementById('vpicker-overlay');
    var swatchesWrap = document.getElementById('vpicker-swatches');
    var atcBtn = document.getElementById('vpicker-atc');
    var closeBtn = document.getElementById('vpicker-close');
    if (!overlay || !swatchesWrap || !atcBtn) return;

    var pickedId = null;

    var options = swatchesWrap.querySelectorAll('.vpicker__option');
    options.forEach(function (btn) {
      var swatch = btn.querySelector('.vpicker__swatch');
      btn.addEventListener('click', function () {
        swatchesWrap.querySelectorAll('.vpicker__swatch').forEach(function (s) { s.classList.remove('active'); });
        if (swatch) swatch.classList.add('active');
        pickedId = btn.dataset.variantId ? Number(btn.dataset.variantId) : null;
        atcBtn.disabled = !pickedId;
        var thumb = document.getElementById('vpicker-thumb');
        var matchSrc = document.querySelector('.shop__color-option[data-variant-name="' + btn.dataset.variantName + '"]');
        if (thumb && matchSrc) thumb.src = matchSrc.dataset.variantImage || '';
      });
    });

    var firstSrc = document.querySelector('.shop__color-option');
    var thumb = document.getElementById('vpicker-thumb');
    if (thumb && firstSrc) thumb.src = firstSrc.dataset.variantImage || '';

    function openModal() { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeModal() { overlay.classList.remove('open'); document.body.style.overflow = ''; }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });

    atcBtn.addEventListener('click', function () {
      if (!pickedId) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      if (window.NIUD) window.NIUD.selectedVariantId = pickedId;
      var hiddenInput = document.getElementById('shop-atc-variant-id');
      if (hiddenInput) hiddenInput.value = pickedId;

      var matchingSwatch = document.querySelector('.shop__color-option[data-variant-id="' + pickedId + '"]');
      if (matchingSwatch) matchingSwatch.click();

      addToCartAndRedirect(pickedId, 1)
        .then(function () {
          closeModal();
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        })
        .catch(function () {
          closeModal();
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        });
    });

    window.NIUD = window.NIUD || {};
    window.NIUD.openVariantPicker = openModal;
  }

  // ── Sticky ATC Inline Picker ─────────────────────────────────────────
  function formatMoney(cents, format) {
    function grouped(decimals, thousands, decimalMark) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimalMark);
    }
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      if (name === 'amount_no_decimals') return grouped(0, ',', '.');
      if (name === 'amount_with_comma_separator') return grouped(2, '.', ',');
      if (name === 'amount_no_decimals_with_comma_separator') return grouped(0, '.', ',');
      return grouped(2, ',', '.');
    });
  }

  function initStickyInlinePicker() {
    var bar = document.getElementById('sticky-atc');
    if (!bar || !bar.hasAttribute('data-inline-picker')) return;
    var panel = document.getElementById('sticky-atc-panel');
    var addBtn = bar.querySelector('[data-atc-btn]');
    var optionsWrap = document.getElementById('sticky-atc-options');
    if (!panel || !addBtn || !optionsWrap) return;

    var fallbackPrice = Number(bar.dataset.unitPrice) || 0;
    var moneyFormat = bar.dataset.moneyFormat || '';
    var maxQty = Number(bar.dataset.maxQty) || 5;
    var threshold = Number(bar.dataset.shipThreshold) || 0;

    var shipWrap = document.getElementById('sticky-atc-ship');
    var shipText = document.getElementById('sticky-atc-ship-text');
    var shipFill = document.getElementById('sticky-atc-ship-fill');
    var qtyValue = document.getElementById('sticky-atc-qty');
    var priceEl = document.getElementById('sticky-atc-price');
    var options = Array.prototype.slice.call(optionsWrap.querySelectorAll('.sticky-atc__option'));
    var decBtn = panel.querySelector('[data-qty-step="-1"]');
    var incBtn = panel.querySelector('[data-qty-step="1"]');
    var tierBtns = Array.prototype.slice.call(panel.querySelectorAll('[data-qty-set]'));
    var tierStepper = document.getElementById('sticky-atc-tier-qty');
    var tierPrice = panel.querySelector('[data-tier-price]');
    // With tiers, the stepper belongs to the "2+ pairs" choice, so it stops at 2.
    var minQty = tierBtns.length ? 2 : 1;
    var closeBtn = document.getElementById('sticky-atc-close');

    var MIRROR_SEL = '.shop__color-option, .bshop__size-option';
    var qty = Math.min(maxQty, Number(bar.dataset.defaultQty) || 1);
    var pickedId = null;
    var busy = false;
    var syncing = false;

    function syncPadding() {
      if (window.NIUD && window.NIUD.syncStickyPadding) window.NIUD.syncStickyPadding();
    }

    // Price follows the selected variant, so per-variant pricing set in the
    // Shopify admin flows through without touching the theme.
    function unitPrice() {
      var active = options.filter(function (o) { return o.classList.contains('active'); })[0];
      var variantPrice = active && Number(active.dataset.variantPrice);
      return variantPrice || fallbackPrice;
    }

    function renderTotals() {
      var total = unitPrice() * qty;
      if (qtyValue) qtyValue.textContent = String(qty);
      if (priceEl) priceEl.textContent = formatMoney(total, moneyFormat);
      if (decBtn) decBtn.disabled = qty <= minQty;
      if (incBtn) incBtn.disabled = qty >= maxQty;
      tierBtns.forEach(function (t) { t.classList.toggle('active', (t.dataset.qtySet === '1') === (qty === 1)); });
      if (tierStepper) tierStepper.classList.toggle('is-off', qty === 1);
      if (tierPrice && qty > 1) tierPrice.textContent = formatMoney(total, moneyFormat).replace(/[.,]00(?=\D*$)/, '');

      if (!threshold || !shipWrap) return;
      var met = total >= threshold;
      shipWrap.classList.toggle('sticky-atc__ship--met', met);
      if (shipText) {
        shipText.textContent = met
          ? 'Free shipping unlocked'
          : formatMoney(threshold - total, moneyFormat) + ' away from free shipping';
      }
      if (shipFill) {
        var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
        shipFill.style.width = pct + '%';
      }
    }

    function select(btn) {
      if (!btn || btn.disabled) return;
      options.forEach(function (o) { o.classList.toggle('active', o === btn); });
      pickedId = Number(btn.dataset.variantId) || null;
    }

    function optionFor(variantId) {
      if (!variantId) return null;
      return options.filter(function (o) { return o.dataset.variantId === String(variantId); })[0] || null;
    }

    // What the rest of the page currently has selected, in order of authority.
    function pageVariantId() {
      var hidden = document.getElementById('shop-atc-variant-id');
      if (hidden && hidden.value && hidden.value !== '0') return hidden.value;
      if (window.NIUD && window.NIUD.selectedVariantId) return window.NIUD.selectedVariantId;
      var activeMirror = document.querySelector('.bshop__size-swatch.active, .shop__color-swatch.active');
      var owner = activeMirror && activeMirror.closest(MIRROR_SEL);
      return owner ? owner.dataset.variantId : null;
    }

    // Page → panel.
    function syncFromPage() {
      var match = optionFor(pageVariantId());
      if (match && !match.disabled) select(match);
    }

    // Panel → page. Reuses each picker's own click handler so their side
    // effects (gallery swap, price, hidden input) stay in one place.
    function syncToPage(variantId) {
      var mirror = document.querySelector(
        '.shop__color-option[data-variant-id="' + variantId + '"], .bshop__size-option[data-variant-id="' + variantId + '"]'
      );
      if (!mirror || mirror.disabled) return;
      syncing = true;
      mirror.click();
      syncing = false;
    }

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn);
        renderTotals();
        if (pickedId) syncToPage(pickedId);
      });
    });

    // Read the clicked element's own id: this listener is registered before
    // the on-page pickers', so the shared hidden input is still stale here.
    document.querySelectorAll(MIRROR_SEL).forEach(function (mirror) {
      mirror.addEventListener('click', function () {
        if (syncing || mirror.disabled) return;
        var match = optionFor(mirror.dataset.variantId);
        if (match && !match.disabled) { select(match); renderTotals(); }
      });
    });

    panel.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty = Math.min(maxQty, Math.max(minQty, qty + Number(btn.dataset.qtyStep)));
        renderTotals();
      });
    });

    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty = btn.dataset.qtySet === '1' ? 1 : Math.max(2, qty);
        renderTotals();
      });
    });

    function isOpen() { return !panel.hidden; }

    function open() {
      if (isOpen()) return;
      panel.hidden = false;
      if (closeBtn) closeBtn.hidden = false;
      syncFromPage();
      if (!pickedId) {
        var first = options.filter(function (o) { return !o.disabled; })[0];
        if (first) select(first);
        if (pickedId) syncToPage(pickedId);
      }
      renderTotals();
      syncPadding();
    }

    function close() {
      if (!isOpen()) return;
      panel.hidden = true;
      if (closeBtn) closeBtn.hidden = true;
      syncPadding();
    }

    if (closeBtn) closeBtn.addEventListener('click', close);

    // With tiers, the shade-only modal would skip the pairs choice and add 1,
    // so every other Add to Cart button opens this panel instead.
    if (tierBtns.length && window.NIUD) {
      window.NIUD.openVariantPicker = function () {
        bar.classList.add('visible');
        open();
      };
    }

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!isOpen()) { open(); return; }
      if (!pickedId) return;

      busy = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addBtn.classList.add('is-busy');

      if (window.NIUD) window.NIUD.selectedVariantId = pickedId;
      var hiddenInput = document.getElementById('shop-atc-variant-id');
      if (hiddenInput) hiddenInput.value = pickedId;
      addToCartAndRedirect(pickedId, qty)
        .catch(function () { /* surfaced by addToCartAndRedirect */ })
        .then(function () {
          busy = false;
          addBtn.textContent = label;
          addBtn.classList.remove('is-busy');
          close();
        });
    });

    // syncToPage() forwards the pick by clicking the on-page picker, which sits
    // outside the bar. That synthetic click bubbles here and would read as an
    // outside click, closing the panel the visitor is still using.
    document.addEventListener('click', function (e) {
      if (!isOpen() || syncing) return;
      if (bar.contains(e.target)) return;
      // Choosing a size anywhere on the page is the same action this panel
      // offers, so it is never a reason to close it. The size finder forwards
      // its recommendation the same way, from its own closure where the
      // syncing flag above is out of reach, and it forwards to the popup's
      // swatches as well as the page's — so both are listed here.
      if (e.target.closest && e.target.closest(MIRROR_SEL + ', .vpicker__option')) return;
      // With tiers, the page's other Add to Cart buttons open this panel.
      if (tierBtns.length && e.target.closest && e.target.closest('[data-atc-btn]')) return;
      close();
    });

    window.addEventListener('resize', function () { if (isOpen()) syncPadding(); }, { passive: true });

    syncFromPage();
    renderTotals();
  }

  // ── ATC button wiring ────────────────────────────────────────────────
  function scrollToSwatches() {
    var colorsSection = document.querySelector('.shop__colors');
    if (!colorsSection) return;
    colorsSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    colorsSection.classList.add('shop__colors--highlight');
    setTimeout(function () { colorsSection.classList.remove('shop__colors--highlight'); }, 2500);
  }

  // ── shopTiers (1 pair / 2+ pairs in the shop section) ───────────────
  // The 2+ radio carries the stepper's count as its value, so the shop form
  // submit sends whatever is selected without knowing about tiers.
  function shopTiers() {
    var wrap = document.querySelector('[data-shop-tiers]');
    if (!wrap) return;
    var countEl = wrap.querySelector('[data-tier-count]');
    var priceEl = wrap.querySelector('[data-tier-price]');
    var steps = wrap.querySelectorAll('[data-tier-step]');
    var radio = countEl && countEl.closest('.shop__tier').querySelector('input[type="radio"]');
    if (!radio) return;
    var unit = Number(wrap.dataset.unitPrice) || 0;
    var maxQty = Number(wrap.dataset.maxQty) || 5;
    var count = 2;

    function render() {
      radio.value = String(count);
      countEl.textContent = String(count);
      if (priceEl) priceEl.textContent = formatMoney(unit * count, wrap.dataset.moneyFormat).replace(/[.,]00(?=\D*$)/, '');
      steps.forEach(function (s) {
        s.disabled = Number(s.dataset.tierStep) < 0 ? count <= 2 : count >= maxQty;
      });
    }

    steps.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        count = Math.min(maxQty, Math.max(2, count + Number(btn.dataset.tierStep)));
        radio.checked = true;
        render();
      });
    });
    render();
  }

  function wireAtcButtons() {
    var atcMode = new URLSearchParams(window.location.search).get('atc') || 'modal';
    var btns = document.querySelectorAll('[data-atc-btn]');
    btns.forEach(function (btn) {
      if (btn.closest('[data-inline-picker]')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.NIUD && window.NIUD.openVariantPicker) {
          window.NIUD.openVariantPicker();
        }
      });
    });

    var shopForm = document.getElementById('shop-atc-form');
    if (shopForm) {
      shopForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var hiddenInput = document.getElementById('shop-atc-variant-id');
        if (!hiddenInput || !hiddenInput.value || hiddenInput.value === '0') {
          scrollToSwatches();
          return;
        }
        var submitBtn = shopForm.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        var qtyField = shopForm.elements.quantity;
        addToCartAndRedirect(Number(hiddenInput.value), Number(qtyField && qtyField.value) || 1)
          .finally(function () { if (submitBtn) submitBtn.disabled = false; });
      });
    }
  }

  // ── usecasesCarousel ─────────────────────────────────────────────────
  function usecasesCarousel() {
    var section = document.querySelector('.usecases');
    if (!section) return;

    var carousel = section.querySelector('.usecases__carousel');
    var slides = section.querySelectorAll('.usecases__slide');
    var segs = section.querySelectorAll('.usecases__progress-seg');
    var outfits = section.querySelectorAll('.usecases__outfit');
    var cur = 0;
    var timer = null;
    var idleTimer = null;
    var programmatic = false;

    function setActive(idx) {
      cur = idx;
      slides.forEach(function (s, i) { s.classList.toggle('usecases__slide--active', i === idx); });
      segs.forEach(function (s, i) { s.classList.toggle('usecases__progress-seg--active', i === idx); });
      outfits.forEach(function (o, i) { o.classList.toggle('usecases__outfit--active', i === idx); });
      if (carousel) carousel.style.setProperty('--active', idx);
    }

    function scrollTo(idx) {
      if (!carousel || window.innerWidth >= 768) return;
      programmatic = true;
      carousel.scrollTo({ left: idx * carousel.offsetWidth, behavior: 'smooth' });
      setTimeout(function () { programmatic = false; }, 400);
    }

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(function () {
        var next = (cur + 1) % slides.length;
        setActive(next);
        scrollTo(next);
      }, parseInt(section.dataset.carouselInterval) || 1000);
    }

    function pauseAndResume() {
      clearInterval(timer);
      clearTimeout(idleTimer);
      idleTimer = setTimeout(startAutoplay, 5000);
    }

    segs.forEach(function (seg, i) {
      seg.addEventListener('click', function () {
        setActive(i);
        scrollTo(i);
        pauseAndResume();
      });
    });

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (i !== cur) { setActive(i); scrollTo(i); pauseAndResume(); }
      });
    });

    if (carousel) {
      carousel.addEventListener('scroll', function () {
        if (programmatic || window.innerWidth >= 768) return;
        var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        if (idx !== cur && idx >= 0 && idx < slides.length) {
          setActive(idx);
          pauseAndResume();
        }
      });
    }

    setActive(0);

    var ucObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { startAutoplay(); } else { clearInterval(timer); }
    }, { threshold: 0.1 });
    ucObs.observe(section);
  }

  // ── whatareSteps (Boosters: how-to pills autoplay) ──────────────────
  function whatareSteps() {
    var pills = document.querySelector('.whatare__apply-pills');
    if (!pills) return;

    var items = pills.querySelectorAll('.whatare__apply-pill-item');
    var segs = document.querySelectorAll('.whatare__apply-progress-seg');
    var interval = parseInt(pills.dataset.autoplayInterval) || 3500;
    var cur = 0;
    var timer = null;
    var resumeTimer = null;

    // The GIF reel is a scroll carousel, so it drives the step index as well as
    // following it. A slide carries the step it belongs to, since a step with no
    // GIF is skipped and DOM order alone would drift out of step with the pills.
    var reel = document.querySelector('[data-apply-reel]');
    var slides = reel ? Array.prototype.slice.call(reel.querySelectorAll('[data-apply-slide]')) : [];
    var reelLockUntil = 0;

    function slideCentre(el) {
      return el.offsetLeft + el.offsetWidth / 2;
    }

    function scrollReelTo(idx) {
      if (!reel) return;
      var target = null;
      slides.forEach(function (el) {
        if (parseInt(el.dataset.applySlide, 10) === idx) target = el;
      });
      if (!target) return;
      reelLockUntil = Date.now() + 700;
      reel.scrollTo({ left: slideCentre(target) - reel.clientWidth / 2, behavior: 'smooth' });
    }

    function setActive(idx, fromReel) {
      cur = ((idx % items.length) + items.length) % items.length;
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === cur); });
      segs.forEach(function (s, i) { s.classList.toggle('is-active', i === cur); });
      slides.forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.dataset.applySlide, 10) === cur);
      });
      pills.style.setProperty('--active', cur);
      if (!fromReel) scrollReelTo(cur);
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(function () { setActive(cur + 1); }, interval);
    }

    function userSelect(idx) {
      setActive(idx);
      clearInterval(timer);
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAuto, 6000);
    }

    items.forEach(function (it, i) {
      var btn = it.querySelector('.whatare__apply-pill');
      if (btn) btn.addEventListener('click', function () { userSelect(i); });
    });
    segs.forEach(function (s, i) {
      s.addEventListener('click', function () { userSelect(i); });
    });

    if (reel) {
      var settleTimer = null;
      reel.addEventListener('scroll', function () {
        if (Date.now() < reelLockUntil) return;
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          var mid = reel.scrollLeft + reel.clientWidth / 2;
          var nearest = cur;
          var best = Infinity;
          slides.forEach(function (el) {
            var d = Math.abs(slideCentre(el) - mid);
            if (d < best) { best = d; nearest = parseInt(el.dataset.applySlide, 10); }
          });
          // Only treat this as a user action if the reel actually landed on a
          // different step. A long autoplay scroll can outrun the lock above and
          // would otherwise pause the autoplay it just triggered.
          if (nearest !== cur) {
            setActive(nearest, true);
            clearInterval(timer);
            clearTimeout(resumeTimer);
            resumeTimer = setTimeout(startAuto, 6000);
          }
        }, 120);
      }, { passive: true });
    }

    setActive(0);

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { startAuto(); } else { clearInterval(timer); }
    }, { threshold: 0.1 });
    io.observe(pills);
  }

  // ── bshopGallery (Boosters: thumbs incl. pouch slide) ───────────────
  function bshopGallery() {
    var section = document.querySelector('.bshop');
    if (!section) return;

    var mainImg = document.getElementById('bshop-main-img');
    var pouch = document.getElementById('bshop-pouch');
    var thumbs = section.querySelectorAll('.bshop__gallery-thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (thumb.dataset.thumbKind === 'pouch') {
          if (mainImg) mainImg.hidden = true;
          if (pouch) pouch.hidden = false;
        } else {
          if (pouch) pouch.hidden = true;
          if (mainImg) {
            mainImg.hidden = false;
            if (thumb.dataset.thumbSrc) mainImg.src = thumb.dataset.thumbSrc;
          }
        }
      });
    });
  }

  // ── bshopSizePicker (Boosters: size swatches → variant id) ──────────
  function bshopSizePicker() {
    var section = document.querySelector('.bshop');
    if (!section) return;

    var options = section.querySelectorAll('.bshop__size-option');
    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        options.forEach(function (o) {
          var sw = o.querySelector('.bshop__size-swatch');
          if (sw) sw.classList.remove('active');
        });
        var swatch = btn.querySelector('.bshop__size-swatch');
        if (swatch) swatch.classList.add('active');

        // Per-variant pricing set in the Shopify admin flows straight through.
        var priceEl = document.getElementById('shop-price');
        if (priceEl && btn.dataset.priceText) priceEl.textContent = btn.dataset.priceText;

        var variantId = btn.dataset.variantId;
        if (variantId && window.NIUD) window.NIUD.selectedVariantId = variantId;
        var hiddenInput = document.getElementById('shop-atc-variant-id');
        if (hiddenInput && variantId) hiddenInput.value = variantId;
      });
    });
  }

  // ── bshopSizeFinder (Boosters: band/cup quiz + notify) ──────────────
  function bshopSizeFinder() {
    var section = document.querySelector('.bshop');
    if (!section) return;
    var origin = section.querySelector('.bshop__size-finder');
    if (!origin) return;

    var sizeMap;
    try { sizeMap = JSON.parse(section.dataset.sizeMap || '{}'); } catch (e) { return; }
    var bands = Object.keys(sizeMap);
    if (!bands.length) return;
    var cups = Object.keys(sizeMap[bands[0]]);

    // The ATC popup and the sticky bar's panel both need the finder, and
    // neither can reach this section's settings, so each gets a clone of the
    // on-page finder instead of its own copy of the markup. Merchant copy and
    // the size map stay in one place.
    var slots = ['vpicker-finder', 'sticky-atc-finder']
      .map(function (id) { return document.getElementById(id); })
      .filter(Boolean);
    slots.forEach(function (slot) {
      if (!slot.childElementCount) slot.appendChild(origin.cloneNode(true));
    });

    function applyRecommendation(rec) {
      var match = section.querySelector('.bshop__size-option[data-size-name="' + rec + '"]');
      if (match && !match.disabled) match.click();
      var picked = document.querySelector('.vpicker__option[data-variant-name="' + rec + '"]');
      if (picked && !picked.disabled) picked.click();
    }

    function initFinder(root) {
      var bandsWrap = root.querySelector('[data-finder-bands]');
      var cupsWrap = root.querySelector('[data-finder-cups]');
      if (!bandsWrap || !cupsWrap) return;

      var cupWrapOuter = root.querySelector('[data-finder-cup-wrap]');
      var resultEl = root.querySelector('[data-finder-result]');
      var notifyEl = root.querySelector('[data-finder-notify]');
      var notifyDoneEl = root.querySelector('[data-finder-notify-done]');
      var recSizeEl = root.querySelector('[data-finder-rec-size]');
      var braSizeEl = root.querySelector('[data-finder-bra-size]');

      var selBand = null;
      var selCup = null;

      function hideResults() {
        if (resultEl) resultEl.hidden = true;
        if (notifyEl) notifyEl.hidden = true;
        if (notifyDoneEl) notifyDoneEl.hidden = true;
      }

      function renderCups() {
        cupsWrap.innerHTML = '';
        cups.forEach(function (c) {
          var available = sizeMap[selBand] && sizeMap[selBand][c] !== null && sizeMap[selBand][c] !== undefined;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bshop__size-finder-btn' + (selCup === c ? ' active' : '') + (available ? '' : ' disabled');
          btn.textContent = c;
          btn.disabled = !available;
          btn.addEventListener('click', function () {
            selCup = c;
            cupsWrap.querySelectorAll('.bshop__size-finder-btn').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            showResult();
          });
          cupsWrap.appendChild(btn);
        });
      }

      function showResult() {
        hideResults();
        if (!selBand || !selCup) return;
        var rec = sizeMap[selBand] ? sizeMap[selBand][selCup] : null;
        if (rec) {
          if (recSizeEl) recSizeEl.textContent = 'Size ' + rec;
          if (braSizeEl) braSizeEl.textContent = selBand + selCup + ' bra size';
          if (resultEl) resultEl.hidden = false;
          applyRecommendation(rec);
        } else if (notifyEl) {
          notifyEl.hidden = false;
        }
      }

      bands.forEach(function (b) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bshop__size-finder-btn';
        var us = parseInt(b, 10);
        if (isNaN(us)) {
          btn.textContent = b;
        } else {
          // US band → EU band: 28 = 60, +5 per 2 inches
          btn.innerHTML = b + '<span class="bshop__size-finder-eu"> / ' + (60 + (us - 28) * 2.5) + '</span>';
        }
        btn.addEventListener('click', function () {
          selBand = b;
          bandsWrap.querySelectorAll('.bshop__size-finder-btn').forEach(function (x) { x.classList.remove('active'); });
          btn.classList.add('active');
          if (cupWrapOuter) cupWrapOuter.hidden = false;
          renderCups();
          if (selCup) showResult(); else hideResults();
        });
        bandsWrap.appendChild(btn);
      });

      var notifyForm = root.querySelector('[data-notify-form]');
      if (notifyForm) {
        notifyForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var input = notifyForm.querySelector('input[type="email"]');
          if (!input || !input.value) return;
          try {
            var existing = JSON.parse(localStorage.getItem('niud_size_requests') || '[]');
            existing.push({ band: selBand, cup: selCup, email: input.value, at: new Date().toISOString() });
            localStorage.setItem('niud_size_requests', JSON.stringify(existing));
          } catch (err) { /* storage unavailable */ }
          if (notifyEl) notifyEl.hidden = true;
          if (notifyDoneEl) notifyDoneEl.hidden = false;
        });
      }
    }

    initFinder(origin);
    slots.forEach(function (slot) {
      Array.prototype.forEach.call(slot.querySelectorAll('.bshop__size-finder'), initFinder);
    });
  }

  // ── init ─────────────────────────────────────────────────────────────
  // Draw each "How Boosters work" leader from its label card to its anchor dot.
  // Measured at runtime, so lines always meet the cards at any width or copy length.
  function whatareLeaders() {
    var NS = 'http://www.w3.org/2000/svg';
    document.querySelectorAll('.whatare__hero .whatare__stage').forEach(function (stage) {
      var svg = stage.querySelector('.whatare__leaders--js');
      var beats = stage.querySelectorAll('.whatare__beat--callout[data-ax]');
      if (!svg || !beats.length) return;
      var mq = window.matchMedia('(min-width: 768px)');

      function el(tag, attrs) {
        var n = document.createElementNS(NS, tag);
        for (var k in attrs) n.setAttribute(k, attrs[k]);
        return n;
      }

      function draw() {
        var sr = stage.getBoundingClientRect();
        if (!sr.width) return;
        svg.setAttribute('viewBox', '0 0 ' + sr.width + ' ' + sr.height);
        svg.innerHTML = '';
        beats.forEach(function (beat) {
          var d = beat.dataset;
          var ax = parseFloat(mq.matches ? d.ax : d.axM) / 100 * sr.width;
          var ay = parseFloat(mq.matches ? d.ay : d.ayM) / 100 * sr.height;
          if (isNaN(ax) || isNaN(ay)) return;
          var body = beat.querySelector('.whatare__beat-body') || beat;
          var r = body.getBoundingClientRect();
          var L = r.left - sr.left, R = r.right - sr.left, T = r.top - sr.top, B = r.bottom - sr.top;
          var cy = (T + B) / 2, pts;
          if (ax < L - 8) pts = [[L, cy], [ax, cy], [ax, ay]];
          else if (ax > R + 8) pts = [[R, cy], [ax, cy], [ax, ay]];
          else if (ay > B) pts = [[ax, B], [ax, ay]];
          else pts = [[ax, T], [ax, ay]];
          var dStr = pts.map(function (p, i) { return (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' ');
          svg.appendChild(el('path', { d: dStr, fill: 'none', stroke: 'rgba(255,247,235,0.75)', 'stroke-width': 3.5, 'stroke-linejoin': 'round' }));
          svg.appendChild(el('path', { d: dStr, fill: 'none', stroke: 'var(--deep-brown)', 'stroke-width': 1.25, 'stroke-linejoin': 'round' }));
          svg.appendChild(el('circle', { cx: pts[0][0], cy: pts[0][1], r: 2.5, fill: 'var(--deep-brown)' }));
          svg.appendChild(el('circle', { cx: ax, cy: ay, r: 7, fill: '#F2D9B3', stroke: 'var(--deep-brown)', 'stroke-width': 1.5 }));
        });
        stage.classList.add('has-js-leaders');
      }

      var raf;
      function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); }
      schedule();
      window.addEventListener('resize', schedule);
      if (window.ResizeObserver) new ResizeObserver(schedule).observe(stage);
      stage.addEventListener('transitionend', schedule);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    });
  }

  function initAll() {
    trackHighClicks();
    inViewObserver();
    whyNiudScrolljack();
    beforeAfterSlider();
    baCarousel();
    colorSwatchPicker();
    stickyAtcBar();
    initVariantPickerModal();
    initStickyInlinePicker();
    shopTiers();
    wireAtcButtons();
    usecasesCarousel();
    accordion('.faq', '.faq__item', '.faq__q', 'open');
    accordion('.shop__specs', '.shop__spec', '.shop__spec-toggle', 'open');
    accordion('.bshop__specs', '.bshop__spec', '.bshop__spec-toggle', 'open');
    whatareSteps();
    whatareLeaders();
    bshopGallery();
    bshopSizePicker();
    bshopSizeFinder();
    loadJudgeMeQuotes(function () {
      initQuoteCarousel();
    });
    NiudCarousel({
      container: '.truths__carousel-outer',
      trackSel: '.truths__carousel-track',
      slideSel: '.truths__slide',
      viewportSel: '.truths__carousel-viewport',
      prevSel: '.truths__arrow--prev',
      nextSel: '.truths__arrow--next',
      segSel: '.truths__seg',
      segActiveClass: 'truths__seg--active',
      activeClass: 'truths__slide--active',
      autoInterval: parseInt((document.querySelector('.truths') || {}).dataset && document.querySelector('.truths').dataset.carouselInterval) || 1500,
      drag: true,
      swipe: true,
      translateMode: true,
      mobileOnly: false,
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  function loadJudgeMeQuotes(cb) {
    var section = document.querySelector('.quote');
    if (!section) return cb();

    var shop = section.dataset.judgemeShop;
    var productId = section.dataset.judgemeProductId;
    var count = parseInt(section.dataset.judgemeCount) || 5;

    if (!shop || !productId) return cb();

    var url = 'https://judge.me/api/v1/reviews?api_token=PUBLIC'
      + '&shop_domain=' + encodeURIComponent(shop)
      + '&product_id=' + encodeURIComponent(productId)
      + '&per_page=' + count
      + '&rating=5';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var reviews = (data.reviews || []).filter(function (r) { return r.rating === 5 && r.body; });
        if (!reviews.length) return cb();

        var content = section.querySelector('.quote__content');
        var dotsContainer = section.querySelector('.quote__dots');
        if (!content || !dotsContainer) return cb();

        content.innerHTML = '';
        dotsContainer.innerHTML = '';

        reviews.forEach(function (r, i) {
          var bq = document.createElement('blockquote');
          bq.className = 'quote__text';
          bq.style.display = i === 0 ? '' : 'none';
          bq.innerHTML = '\u201C' + r.body + '\u201D';
          content.appendChild(bq);

          var attr = document.createElement('p');
          attr.className = 'quote__attribution';
          attr.style.display = i === 0 ? '' : 'none';
          attr.textContent = '\u2014 ' + r.reviewer.name;
          content.appendChild(attr);

          var dot = document.createElement('button');
          dot.className = 'quote__dot' + (i === 0 ? ' quote__dot--active' : '');
          dot.setAttribute('data-carousel-dot', '');
          dot.setAttribute('aria-label', 'Go to quote ' + (i + 1));
          dotsContainer.appendChild(dot);
        });

        cb();
      })
      .catch(function () { cb(); });
  }

  function initQuoteCarousel() {
    var inner = document.querySelector('.quote__inner');
    if (!inner) return;

    var texts = inner.querySelectorAll('.quote__text');
    var attrs = inner.querySelectorAll('.quote__attribution');
    var dots = inner.querySelectorAll('.quote__dot');
    var prevBtn = inner.querySelector('.quote__arrow--left');
    var nextBtn = inner.querySelector('.quote__arrow--right');
    var total = texts.length;
    if (!total) return;

    var cur = 0;
    var timer = null;
    var paused = false;
    var touchStartX = 0;

    var section = document.querySelector('.quote');
    var interval = parseInt(section && section.dataset.carouselInterval) || 2000;

    function show(idx) {
      cur = ((idx % total) + total) % total;
      texts.forEach(function (t, i) { t.style.display = i === cur ? '' : 'none'; });
      attrs.forEach(function (a, i) { a.style.display = i === cur ? '' : 'none'; });
      dots.forEach(function (d, i) {
        d.classList.toggle('quote__dot--active', i === cur);
      });
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(function () {
        if (!paused) show(cur + 1);
      }, interval);
    }

    function userNav(idx) {
      show(idx);
      paused = true;
      setTimeout(function () { paused = false; }, 4000);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { userNav(cur - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { userNav(cur + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { userNav(i); }); });

    inner.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    inner.addEventListener('touchend', function (e) {
      var delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) userNav(delta > 0 ? cur + 1 : cur - 1);
    });

    show(0);

    var quoteObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { startAuto(); } else { clearInterval(timer); }
    }, { threshold: 0.1 });
    quoteObs.observe(inner);
  }

})();
